export const MASS_EDITING_OPERATION = {
  ADD: 0,
  REWRITE: 1,
  REPLACE: 2,
  SET: 3,
  DELETE_ALL: 4,
  REMOVE: 5,
  INSERT_AREA: 6,
  NUMBER: 7,
  PRICE_KU: 8,
  PRICE_BPEJ: 9,
  PRICE_OWN: 10,
  PRICE_T: 11,
  PRICE_T_UPDATE: 12
}

export const REPLACE_VALUE_SEP = '|/_'

const tools = [
  { // 0
    n: 'Přidat',
    f: MASS_EDITING_OPERATION.ADD
  },
  { // 1
    n: 'Přepsat',
    f: MASS_EDITING_OPERATION.REWRITE
  },
  { // 2
    n: 'Nahradit',
    f: MASS_EDITING_OPERATION.REPLACE,
    es: 'hasvalue2'
  },
  { // 3
    n: 'Nastavit',
    f: MASS_EDITING_OPERATION.REWRITE
  },
  { // 4
    n: 'Smazat',
    f: MASS_EDITING_OPERATION.DELETE_ALL,
    e: true
  },
  { // 5
    n: 'Odebrat',
    f: MASS_EDITING_OPERATION.REMOVE
  },
  { // 6
    n: 'Výměra parcely',
    f: MASS_EDITING_OPERATION.INSERT_AREA,
    e: true
  },
  { // 7
    n: 'Číslovat',
    f: MASS_EDITING_OPERATION.NUMBER,
    es: 'isNumber'
  },
  { // 8
    n: 'Ocenit',
    f: MASS_EDITING_OPERATION.PRICE_KU
  },
  { // 9
    n: 'Ocenit',
    f: MASS_EDITING_OPERATION.PRICE_BPEJ
  },
  { // 10
    n: 'Ocenit',
    f: MASS_EDITING_OPERATION.PRICE_OWN
  },
  { // 11
    n: 'Ocenit',
    f: MASS_EDITING_OPERATION.PRICE_T
  },
  { // 12
    f: MASS_EDITING_OPERATION.PRICE_T_UPDATE
  } 

]

function selectTools() {
  let result = []
  for (let i = 0; i < arguments.length; i++) {
    result.push(tools[arguments[i]])
  }
  return result
}

export default selectTools



// WEBPACK FOOTER //
// ./src/components/MassEditingManager/toolsItems.js